var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D5284",
    d: "M20.175 2.294 11 0 1.825 2.294v9.781c0 3.038 1.718 5.544 4.547 7.547a19 19 0 0 0 3.058 1.75q.412.188.774.335l.433.168.198.07L11 22l.363-.125.197-.075q.46-.176 1.01-.428a19 19 0 0 0 3.058-1.75c2.83-2.003 4.547-4.509 4.547-7.547zM11 1.077 19.13 3.11v8.965c0 2.641-1.526 4.867-4.105 6.694-.918.65-1.904 1.2-2.89 1.653q-.389.177-.73.315l-.405.157-.182-.07a17.979 17.979 0 0 1-3.84-2.056l-.273-.196c-2.414-1.79-3.834-3.95-3.834-6.497V3.11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D5E",
    d: "m15.63 6.05.794.681-6.476 7.555-3.653-3.653.74-.739 2.853 2.854z"
  })));
};
export default SvgShield;